import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Head from 'next/head';
import { ParallaxProvider } from 'react-scroll-parallax';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Footer from '@/components/common/widgets/Footer';
import Layout from '@/components/common/layouts/Layout';
import HeroSection from '@/components/homepage/HeroSection';

function TeamPage() {
  return (
    <Layout>
      <style jsx global>
        {`
.cover {
  object-fit: cover;
  width: 280px;
  height: 400px;
}
.top{
    margin-top: 0;
}
.bottom{
    margin-bottom: 0;
}
     `}

      </style>
      <Head>
        <title>Big & Mini: Meet the Team</title>
        <meta name="description" content="Meet the team members behind the scenes at Big & Mini." />

      </Head>
      <ParallaxProvider>
        <HeroSection
          image="/images/teamphotos/team.jpg"
          topSpace={(
            <div>
              <br />
            </div>
                                   )}
          title="Meet the Team"
          description="Composed of engineers, entrepreneurs, writers, and dreamers, Big and Mini is a team united for one goal - to eradicate loneliness."
        />
      </ParallaxProvider>
      <div className="privacy-style">
        <Container fluid="md">
          <br />
          <h1>Our Team</h1>
          <br />
          <Row
                    // className="justify-content-between"
            style={{ margin: 'auto', textAlign: 'center' }}
          >
            <Col md={6} lg={4}>
              <img className="cover" src="/images/teamphotos/Copy of profile-pic.jpeg" alt="Allen Zhou" />
              <p />
              <p className="bottom"><strong>Allen Zhou</strong></p>
              <p className="top">CEO, Co-founder</p>
            </Col>
            <Col md={6} lg={4}>
              <img className="cover" src="/images/teamphotos/Copy of prof_pic.jpg" alt="Aditi Merchant" />
              <p />
              <p className="bottom"><strong>Aditi Merchant</strong></p>
              <p className="top">COO, Co-founder</p>
            </Col>
            <Col md={6} lg={4}>
              <img className="cover" src="/images/teamphotos/Copy of Anthony Zhou.JPG" alt="Anthony Zhou" />
              <p />
              <p className="bottom"><strong>Anthony Zhou</strong></p>
              <p className="top">CTO, Co-founder</p>
            </Col>

            <Col md={6} lg={4}>
              <img className="cover" src="/images/teamphotos/AveryGann.jpg" alt="Avery Gann" />
              <p />
              <p className="bottom"><strong>Avery Gann</strong></p>
              <p className="top">Editor-in-Chief</p>
            </Col>
            <Col md={6} lg={4}>
              <img className="cover" src="/images/teamphotos/IMG_1824.jpg" alt="Danny Zhang" />
              <p />
              <p className="bottom"><strong>Danny Zhang</strong></p>
              <p className="top">Software Engineer</p>
            </Col>
            <Col md={6} lg={4}>
              <img className="cover" src="/images/teamphotos/Profile Picture.jpg" alt="Mayank Daruka" />
              <p />
              <p className="bottom"><strong>Mayank Daruka</strong></p>
              <p className="top">Software Engineer</p>
            </Col>

            <Col md={6} lg={4}>
              <img className="cover" src="/images/teamphotos/IMG_8098.jpg" alt="Ayushi Merchant" />
              <p />
              <p className="bottom"><strong>Ayushi Merchant</strong></p>
              <p className="top">Graphics Director</p>
            </Col>
            {/* <Col md = {6} lg ={4}><img className = "cover" src = '/images/teamphotos/havakanebio.jpg' alt = "Hava Kane"/><p></p><p className="bottom"><strong>Hava Kane</strong></p><p class = "top">Outreach Director</p></Col> */}
            <Col md={6} lg={4}>
              <img className="cover" src="/images/teamphotos/IMG_4463.PNG" alt="Daniel Formella" />
              <p />
              <p className="bottom"><strong>Daniel Formella</strong></p>
              <p className="top">Communications Director</p>
            </Col>
            <Col md={6} lg={4}>
              <img className="cover" src="/images/teamphotos/chelsea.jpeg" alt="Karen Fingerman" />
              <p />
              <p className="bottom"><strong>Chelsea Vu</strong></p>
              <p className="top">FAM Director</p>
            </Col>

            <Col md={6} lg={4}>
              <img className="cover" src="/images/teamphotos/karen_fingerman.jpg" alt="Karen Fingerman" />
              <p />
              <p className="bottom"><strong>Karen Fingerman, PhD</strong></p>
              <p className="top">Advisor</p>
            </Col>
            <Col md={6} lg={4}>
              <img className="cover" src="/images/teamphotos/colby_takeda.jpg" alt="Colby Takeda" />
              <p />
              <p className="bottom"><strong>Colby Takeda, MBA</strong></p>
              <p className="top">Advisor</p>
            </Col>
            <Col md={6} lg={4}>
              <img className="cover" src="/images/teamphotos/Michael_Hole.jpeg" alt="Michael Hole" />
              <p />
              <p className="bottom"><strong>Michael Hole, MD, MBA</strong></p>
              <p className="top">Advisor</p>
            </Col>
          </Row>
        </Container>
        <p />
        <Container>
          <br />
          <br />
          <p />
          <h1>Want to get involved?</h1>
          <br />
          <Card>
            <Card.Body>
              <h3>Volunteer Positions</h3>
              <hr />
              <h5>Community Manager</h5>
              <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                <Card.Text style={{ marginRight: '2em' }}>Are you a social media expert looking to make a difference with your work? We're looking for a manager to oversee our social media strategy and content creation.</Card.Text>
                <Card.Link className="btn btn-primary btn-lg" href="https://docs.google.com/document/d/18HdQSHfMtE4oXHv5l1ludF5VX_1LRN-rAsEZ3ZPX3uY/edit?usp=sharing" target="_blank">Apply</Card.Link>
              </div>
              <br />
              <h5>UX Copywriter</h5>
              <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                <Card.Text style={{ marginRight: '3em' }}>We need someone to work closely with our designers and developers to write concise UX copy, and curate a unique voice for the Big and Mini platform.</Card.Text>
                <Card.Link className="btn btn-primary btn-lg" href="mailto:contact@bigandmini.org?subject=Interested in Applying as a UX Copywriter">Apply</Card.Link>
              </div>
              <br />
              <h5>Local Outreach Coordinators</h5>
              <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                <Card.Text style={{ marginRight: '3em' }}>We're looking for motivated individuals interested in promoting Big and Mini's cause and platform across their local communities.</Card.Text>
                <Card.Link className="btn btn-primary btn-lg" href="mailto:contact@bigandmini.org?subject=Interested in Applying as a Local Outreach Coordinator">Apply</Card.Link>
              </div>
              <br />
              <h5>Developers</h5>
              <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                <Card.Text style={{ marginRight: '3em' }}>We're looking for developers that can help us make better, faster, and smarter code. We're open to all tech-savvy creators. Calling all frontend, backend, and full-stack developers!</Card.Text>
                <Card.Link className="btn btn-primary btn-lg" href="mailto:contact@bigandmini.org?subject=Interested in Applying as a Developer">Apply</Card.Link>
              </div>
              <br />
              {/* <h5>UX Researcher</h5>
                    <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center'}}>
                        <Card.Text style = {{marginRight: "3em"}}>We're looking for a UX researcher to help us lead generative and evaluative research. Will lead user experience optimization and user retention. </Card.Text>
                        <Card.Link className="btn btn-primary btn-lg" href="mailto:contact@bigandmini.org?subject=Interested in Applying as a UX Researcher">Apply</Card.Link>
                    </div>
                    <br/>
                    <h5>Product Designer</h5>
                    <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center'}}>
                        <Card.Text style = {{marginRight: "3em"}}>We're looking for a design lead for Big and Mini that can package our website's cause to effectively appeal to our users. Will work closely with web developers in regards to layout and design choices.</Card.Text>
                        <Card.Link className="btn btn-primary btn-lg"  href="mailto:contact@bigandmini.org?subject=Interested in Applying as a Product Designer">Apply</Card.Link>
                    </div>
                    <br/>
                    <br/> */}
              <p>
                Interested in helping us in another way? We'd love to talk! Get in touch with us at
                {' '}
                <a href="mailto:contact@bigandmini.org">contact@bigandmini.org</a>
                .
              </p>
            </Card.Body>
          </Card>
        </Container>
      </div>
      <br />
      <br />
      <Footer />
    </Layout>
  );
}

export default TeamPage;
